module.exports = __webpack_public_path__ + "img/117.6af7a417.jpg";